export const shouldLoad = () => document.querySelector('.klt-input--single-character') !== undefined;